import type { GameRuntime } from '../game/runtime'
import type { ControlInput } from '../game/types'
import { EMPTY_INPUT } from '../game/vehicle'

export type InputFamily = 'keyboard' | 'touch'

export function hasActiveInput(input: ControlInput): boolean {
  return (
    input.throttle > 0 ||
    input.brake > 0 ||
    input.steer !== 0 ||
    input.drift ||
    input.boost ||
    input.fire ||
    input.reload
  )
}

function otherFamily(family: InputFamily): InputFamily {
  return family === 'keyboard' ? 'touch' : 'keyboard'
}

export class PlayerInputRouter {
  private readonly snapshots: Record<InputFamily, ControlInput> = {
    keyboard: { ...EMPTY_INPUT },
    touch: { ...EMPTY_INPUT },
  }

  private owner: InputFamily | null = null

  constructor(private readonly runtime: GameRuntime) {}

  update(family: InputFamily, input: ControlInput): void {
    this.snapshots[family] = { ...input }
    if (hasActiveInput(input)) {
      this.owner = family
    } else if (this.owner === family) {
      const fallback = otherFamily(family)
      this.owner = hasActiveInput(this.snapshots[fallback]) ? fallback : null
    }
    this.publish()
  }

  clear(family: InputFamily): void {
    this.update(family, EMPTY_INPUT)
  }

  reset(): void {
    this.snapshots.keyboard = { ...EMPTY_INPUT }
    this.snapshots.touch = { ...EMPTY_INPUT }
    this.owner = null
    this.publish()
  }

  private publish(): void {
    this.runtime.setInput(this.owner ? this.snapshots[this.owner] : EMPTY_INPUT)
  }
}
